import React, { createContext, useContext, useEffect, useState } from "react";
import api, { formatApiErrorDetail, getToken, setToken, clearToken } from "../lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, obj = auth
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = getToken();
    if (!token) {
      setUser(false);
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then(({ data }) => setUser(data))
      .catch(() => {
        clearToken();
        setUser(false);
      })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password, remember = true) => {
    const { data } = await api.post("/auth/login", { email, password }, { timeout: 20000 });
    setToken(data.token, remember);
    setUser(data.user);
    api.get("/auth/me").then(({ data: me }) => setUser(me)).catch(() => {});
  };

  const register = async (name, email, password, penName, remember = true) => {
    const { data } = await api.post("/auth/register", { name, email, password, pen_name: penName || "" }, { timeout: 20000 });
    setToken(data.token, remember);
    // Flag a fresh signup so the Dashboard can show a one-time welcome popup.
    try { sessionStorage.setItem("codexstudio:welcome", "1"); } catch { /* ignore */ }
    setUser(data.user);
    api.get("/auth/me").then(({ data: me }) => setUser(me)).catch(() => {});
  };

  const updateProfile = async (payload) => {
    const { data } = await api.put("/auth/profile", payload);
    setUser((u) => ({ ...u, ...data }));
    return data;
  };

  const logout = () => {
    clearToken();
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, updateProfile, patchUser: (patch) => setUser((u) => ({ ...u, ...patch })), formatApiErrorDetail }}>
      {children}
    </AuthContext.Provider>
  );
}
